export const getTimesheets = state => state.timesheets.list;
export const getTableConfig = state => state.timesheets.tableConfig || {};